import { render, staticRenderFns } from "./DocEditor.vue?vue&type=template&id=de5e6ff0"
import script from "./DocEditor.vue?vue&type=script&lang=js"
export * from "./DocEditor.vue?vue&type=script&lang=js"
import style0 from "./DocEditor.vue?vue&type=style&index=0&id=de5e6ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports